import { ViewContainerRef } from "@angular/core";
import { ComponentCreationFactory } from "./component-utils";

export { ComponentCreationFactory } from "./component-utils";

export const ComponentUtils = {
    componentFactory: (containerRef: ViewContainerRef) => new ComponentCreationFactory(containerRef),
};
